<div class="p-4" style="background-color: var(--app-card-bg);">
    <h1>PFM buttons</h1>
    <div class="flex justify-content-between">

        <button class="btn btn-primary">Primary</button>

        <button class="btn btn-secondary">Secondary</button>

        <button class="btn btn-tertiary">Tertiary</button>

        <button class="btn btn-quaternary">Quaternary</button>


    </div>

    <h1>PrimeNG buttons</h1>
    <div class="flex justify-content-between">
        <p-button label="Primary" />
        <p-button label="Primary" icon="pi pi-plus" />
        <p-button label="Primary" icon="pi pi-plus" iconPos="right" />
        <p-button icon="pi pi-plus" />
    </div><br>
    <div class="flex justify-content-between">
        <p-button label="Secondary" severity="secondary" />
        <p-button label="Secondary" severity="secondary" icon="pi pi-plus" />
        <p-button label="Secondary" severity="secondary" icon="pi pi-plus" iconPos="right" />
        <p-button severity="secondary" icon="pi pi-plus" />
    </div><br>
    <div class="flex justify-content-between">
        <p-button label="Text" [text]="true" />
        <p-button label="Text" [text]="true" icon="pi pi-plus" />
        <p-button label="Text" [text]="true" icon="pi pi-plus" iconPos="right" />
        <p-button [text]="true" icon="pi pi-plus" />
    </div><br>
    <div class="flex justify-content-between">
        <p-button label="Success" severity="success" />
        <p-button label="Info" severity="info" />
        <p-button label="Warning" severity="warning" />
<!--
        <p-button label="Help" severity="help" />
-->
        <p-button label="Danger" severity="danger" />
        <p-button label="Contrast" severity="contrast" />

    </div><br>
    <div class="flex justify-content-between">
        <p-button label="Text" [link]="true" />
        <p-button label="Text" [link]="true" icon="pi pi-plus" />
        <p-button label="Text" [link]="true" icon="pi pi-plus" iconPos="right" />
        <p-button [link]="true" icon="pi pi-plus" />
    </div><br>


    <h1>Form widgets</h1>

    <div class="grid justify-content-around">


        <div class="col-2">
            <app-checkbox label="app-checkbox" [formControl]="checkboxControl"></app-checkbox>

        </div>

        <div class="col-2">
            <div class="field-checkbox">
                <input type="checkbox" id="regular-checkbox" [formControl]="checkboxControl">
                <label for="regular-checkbox">Regular Checkbox</label>

            </div>
        </div>

        <div class="col-2">
            <div class="field-checkbox">
                <p-checkbox id="p-checkbox" [binary]="true" [formControl]="checkboxControl"></p-checkbox>
                <label for="p-checkbox">Prime checkbox</label>
            </div>
        </div>

        <div class="col-2">

            <div class="field-checkbox">

                <p-inputSwitch id="p-switch" [formControl]="checkboxControl" />
                <label for="p-switch">Prime Switch</label>
            </div>
        </div>

        <div class="col-2">
            <div class="field-checkbox">
                <app-input-switch label="app-input-switch" [control]="checkboxControl"></app-input-switch>
            </div>
        </div>

    </div>


    <h1>Toasts</h1>
    <div class="flex justify-content-around">

        <p-splitButton label="Show PrimeNG toast" [model]="toastOptions" (onClick)="showToast()"></p-splitButton>

    </div>

    <h1>Tags</h1>
    <div class="flex justify-content-around">
        <p-tag value="Primary"/>
        <p-tag severity="success" value="Success"/>
        <p-tag severity="secondary" value="Secondary"/>
        <p-tag severity="info" value="Info"/>
        <p-tag severity="warning" value="Warning"/>
        <p-tag severity="danger" value="Danger"/>
        <p-tag severity="contrast" value="Contrast"/>
    </div>

    <h1>Messages</h1>
    <div class="flex justify-content-around">
        <p-message
            severity="success"
            text="Success — This is a success message" />
        <p-message severity="info" text="Info — This is an info message" />
        <p-message severity="warn" text="Warning — This is a warning message" />
        <p-message severity="error" text="Error — This is an error message" />
        <p-message
            severity="secondary"
            text="Secondary — This is a secondary message" />
        <p-message
            severity="contrast"
            text="Contrast — This is a contrast message" />
    </div>
    <h1>Inputs</h1>
    <div class="grid">
        <div class="col-4">
            <label>Input with icon</label>
            <p-iconField iconPosition="right">
                <input type="text" pInputText placeholder="Search" [formControl]="searchControl" />
                <p-inputIcon styleClass="pi pi-times" (click)="clearSearch()" />
            </p-iconField>
        </div>

        <div class="col-4">
            <label>Prime typeahead</label>
            <p-autoComplete
                placeholder="Search fruits"
                [suggestions]="suggestions"
                (completeMethod)="search($event)"
                [formControl]="searchControl"

            ></p-autoComplete>
        </div>

        <div class="col-4">
            <label>Autocomplete Multi</label>
            <p-autoComplete
                styleClass="w-full"
                placeholder="Search fruits"
                [suggestions]="suggestions"
                (completeMethod)="search($event)"
                [formControl]="multiSelectControl"
                [multiple]="true"
            ></p-autoComplete>
        </div>
    </div>
    <div class="grid">
        <div class="col-6">
            <h1>Table Example</h1>

            <div class="mt-4">
                <p-table 
                    [value]="sampleFlights" 
                    [(selection)]="selectedFlights"
                    [tableStyle]="{ 'min-width': '30rem' }" 
                    [scrollable]="true" 
                    scrollHeight="30rem"
                    (onRowSelect)="onRowSelect($event)"
                    (onRowUnselect)="onRowUnselect($event)"
                    (onHeaderCheckboxToggle)="onSelectAll($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 3rem">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th>
                            <th [pSortableColumn]="'flightDate'">
                                Date
                                <p-sortIcon [field]="'flightDate'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'status'">
                                Status
                                <p-sortIcon [field]="'status'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'departure_airport.code'">
                                Departure
                                <p-sortIcon [field]="'departure_airport.code'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'arrival_airport.code'">
                                Destination
                                <p-sortIcon [field]="'arrival_airport.code'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'aircraft.designation'">
                                Aircraft
                                <p-sortIcon [field]="'aircraft.designation'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'customIdentifier'">
                                Identifier
                                <p-sortIcon [field]="'customIdentifier'"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-flight>
                        <tr [pSelectableRow]="flight">
                            <td>
                                <p-tableCheckbox [value]="flight"></p-tableCheckbox>
                            </td>
                            <td>{{ flight.flightDate | date: 'short' }}</td>
                            <td>
                                <span class="trip-status {{ flight.status === 'in progress' ? 'in-progress' : flight.status }} inline-flex align-items-center text-xs font-bold border-round px-2 py-1 uppercase w-max">
                                    {{ flight.status | uppercase }}
                                </span>
                            </td>
                            <td>{{ flight.departure_airport?.code }}</td>
                            <td>{{ flight.arrival_airport?.code }}</td>
                            <td>{{ flight.aircraft?.designation }}</td>
                            <td>{{ flight.customIdentifier }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

        </div>
        <div class="col-6">
            <h1>Activity timeline (shared component)</h1>
            <div class="mt-4">
                <app-activity-timeline
                    [items]="sampleActivities"
                    [parentId]="'playground-parent'"
                    [parentType]="'frat'">
                </app-activity-timeline>
            </div>
        </div>
    </div>
</div>
